import React from "react";
import TestimonialContent from "../TestimonialContent";

function Testimonial() {
  return (
    <>
      <TestimonialContent />
    </>
  );
}

export default Testimonial;
